module.exports = __webpack_public_path__ + "img/Envelope.5e2114df.svg";